import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';
import {ConnectEngine} from '../message/ConnectEngine';
import {ConnectEngineCriteria} from './ConnectEngineCriteria';

export class ConnectEngineWrapper extends BaseWrapper<ConnectEngine, ConnectEngineCriteria, BasicScenario>  {}

